import React from "react";
import { formatReportDate } from "../util";

const ReportDates = ({ start_date, end_date, longView }) => (
  <>
    {(start_date || end_date) && (
      <>
        {start_date && (
          <>
            <span className="b">Detected: </span>
            {formatReportDate(start_date)}
          </>
        )}
        <>
          <span className="b"> | Declared: </span>
          {end_date ? <>{formatReportDate(end_date)}</> : <>TBD</>}
        </>
      </>
    )}
  </>
);

export default ReportDates;
